export default "__VITE_ASSET__719f7257__"